import { FieldValues, UseFormRegister } from 'react-hook-form';

import Input from '../../../components/form/Input';
import { IConfigItemType } from '../validates/sectionBuilderSchema';

import RenderObjectLabel from './RenderObjectLabel';

export interface IPropsEbookCollectionItem {
  type: IConfigItemType.EbookCollection;
  _id?: string;
}

interface IPropsEbookCollectionSectionItem {
  index: number;
  itemData: IPropsEbookCollectionItem;
  register: UseFormRegister<FieldValues>;
  onDeleteSectionItem?: (deleteIndex?: number) => void;
  expanded?: boolean;
}

const EbookCollectionSectionItem = (props: IPropsEbookCollectionSectionItem) => {
  const { index, itemData, register, expanded } = props;

  return (
    <div className="flex justify-between space-x-16">
      <div className="w-full collapse">
        <input type="checkbox" className="peer" defaultChecked={expanded} />
        <div className=" collapse-title bg-systemGrays08FillQuaternary text-systemGrays01LabelPrimary peer-checked:bg-systemGrays08FillQuaternary peer-checked:text-systemGrays01LabelPrimary flex justify-between after:content-['+'] peer-checked:after:content-['-'] ease-out duration-300">
          <span>
            <span>Ebook Collection</span>
            <RenderObjectLabel objectLists={[{ key: 'ebook-collection Id', value: itemData?._id, required: true }]} />
          </span>
        </div>
        <div className="collapse-content text-systemGrays01LabelPrimary peer-checked:bg-systemGrays08FillQuaternary peer-checked:text-systemGrays01LabelPrimary">
          <div className="space-y-8">
            <Input
              register={register}
              required
              label="ebook-collection Id"
              name={`configItems.${index}._id`}
              helperText="Input ebook-collection ID"
              placeholder="ebook-collection ID"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default EbookCollectionSectionItem;
